import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_034.jpg';
page.images = [
  {
    imageId: 'page034_zoom0',
    rectangle: {
      x: 613,
      y: 1093,
      width: 1204,
      height: 1366,
    },
    imageSrc: 'images/page034/034 1.jpg',
  },
  {
    imageId: 'page034_zoom1',
    rectangle: {
      x: 117,
      y: 336,
      width: 220,
      height: 400,
    },
    imageSrc: 'images/page034/034.jpg',
  },
  // {
  //   imageId: 'page034_zoom2',
  //   rectangle: {
  //     x: 133,
  //     y: 336,
  //     width: 194,
  //     height: 186,
  //   },
  //   imageSrc: 'images/page034/034 2.jpg',
  // },
  {
    imageId: 'page034_zoom3',
    rectangle: {
      x: 1357,
      y: 596,
      width: 418,
      height: 304,
    },
    imageSrc: 'images/page034/034 5.jpg',
  },
  {
    imageId: 'page034_zoom4',
    rectangle: {
      x: 1359,
      y: 246,
      width: 416,
      height: 312,
    },
    imageSrc: 'images/page034/034 4.jpg',
  },
];
page.paint = [
  {
    id: 'page017_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      paint3D: true,
      text: 'Narysuj obiekty 3D.',
      additionalLine: 'Narysuj podane obiekty 3D',
      audio: 'files/page017/z17c3.mp3',
      customImage: 'files/page003/1.jpg',
      customImageStyle: {
        cssStyle: {
          top: ' 195px',
          left: '103px',
          width: '629px',
          height: '152px',
        },
      },
      item: {
        path: 'informatyka/files/page017/z.17cw.3.bmp',
      },
      cssStyle: {
        height: '180px',
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  {
    id: 'page017_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page017_game2',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page034_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 1263,
    },
    item: {
      id: 'page034_game10',
    },
    rectangle: {
      id: 'page034_rect0',
    },
  },
  // {
  //   id: 'page010_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 400,
  //   },
  // },
  // {
  //   id: 'page010_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 800,
  //   },
  // },
];
page.rectangle = [
  {
    id: 'page034_rect0',

    tooltip: '',

    linked: ['page034_game10'],
    x: 120,
    y: 1263,
    width: 470,
    height: 1217,
  },
];

export default page;
